var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NEWS_DIAG-1",
    transform: "translate(-100.000000, -1149.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PRODUIT",
    transform: "translate(56.000000, 969.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "raindrops-copy",
    transform: "translate(25.300000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asleep-filled",
    transform: "translate(19.000000, 18.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6038783,1.35239191 C8.05768499,1.92874124 5.79110894,3.36689933 4.1787222,5.44065409 C2.45930192,7.65207023 1.62032394,10.4104678 1.8163332,13.2077246 C2.01234485,16.0049682 3.22776004,18.6186164 5.23869148,20.5671888 C7.24962172,22.5157612 9.89613405,23.6443073 12.6944681,23.7450837 C12.7782572,23.7483415 12.8613622,23.7466851 12.9440263,23.7455976 C13.0013246,23.7448447 13.0584214,23.7441324 13.1153443,23.7441324 L13.1228418,23.7441324 C16.6215155,23.7441324 19.9210945,22.1108032 22.0502455,19.3500012 C20.1178522,19.1121824 18.231452,18.4581576 16.5676555,17.4458451 C14.7696435,16.3518608 13.2218034,14.8335893 12.0914525,13.0551558 C10.9611147,11.2767211 10.2422417,9.22863783 10.0125647,7.13232233 C9.80031633,5.1951725 10.0048015,3.20712417 10.6038783,1.35239191 M11.0625493,0 C11.3767042,0.0116424792 11.6658771,0.17481167 11.8388446,0.438044993 C12.0118239,0.701278316 12.0472638,1.03210542 11.9339937,1.32616705 C10.602646,4.99985085 11.0502776,9.08544203 13.1452865,12.3816332 C15.2402943,15.6778375 18.744505,17.8099314 22.6275759,18.1510218 C22.9731222,18.1715366 23.2814422,18.3754963 23.4362493,18.6859592 C23.5910589,18.9964221 23.5687774,19.3661467 23.3778165,19.6556455 C21.0291735,23.0064878 17.1991701,24.9996367 13.1153443,24.9972657 C12.9603989,24.9972657 12.8039043,25.0034179 12.6458805,24.9972657 C6.22913007,24.7662111 1.01980872,19.718404 0.569738723,13.2955559 C0.119671107,6.87271011 4.57385364,1.14399847 10.8953191,0.0153759123 C10.9505044,0.00536352357 11.0064643,0 11.0625493,0 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLune);
export default __webpack_public_path__ + "static/media/Lune.a8d7f0e1a63cf2620c6c229074d766a6.svg";
export { ForwardRef as ReactComponent };